export const routes = {
  landing: "/",
  home: "/home",
  auth: {
    login: "/auth/login",
    forgotPassword: "/auth/forgot-password",
    signup: "/auth/signup",
  },
  seller: {
    index: "/seller",
    id: (sellerId: string) => `/seller/${sellerId}`,
    signup: "/seller/signup",
    dashboard: "/seller/dashboard",
    myShop: {
      index: "/seller/my-shop",
      addProduct: "/seller/my-shop/add-product",
      product: {
        index: "/seller/my-shop/product",
        id: (productId: string) => `/seller/my-shop/product/${productId}`,
      },
    },
    invoices: "/seller/invoices",
  },
  orders: {
    index: "/orders",
  },
  invoices: {
    index: "/invoices",
    id: (invoiceId: string) => `/invoices/${invoiceId}`,
  },
  payment: {
    success: "/payment/success",
  },
  cart: "/cart",
  categories: {
    index: "/categories",
    id: (categoryId: string) => `/categories/${categoryId}`,
    subCategories: {
      id: (categoryId: string, subCategoryId: string) =>
        `/categories/${categoryId}/${subCategoryId}`,
      subSubCategories: {
        id: (
          categoryId: string,
          subCategoryId: string,
          subSubCategoryId: string,
        ) => `/categories/${categoryId}/${subCategoryId}/${subSubCategoryId}`,
      },
    },
  },
  products: {
    index: "/products",
    id: (productId: string, variantId?: string) =>
      variantId
        ? `/products/${productId}/${variantId}`
        : `/products/${productId}`,
  },
  profile: {
    index: "/profile",
    edit: "/profile/edit",
    deleteAccount: "/profile/delete-account",
    myReferrals: "/profile/my-referrals",
  },
  wishlist: "/wishlist",
  help: {
    index: "/help",
    raise: "/help/raise",
    pastQueries: "/help/past-queries",
  },
  wallet: {
    index: "/wallet",
  },
  privacyPolicy: {
    user: "/privacy-policy/user",
    seller: "/privacy-policy/seller",
  },
  termsAndConditions: {
    user: "/terms-and-conditions/user",
    seller: "/terms-and-conditions/seller",
  },
};
